import { BlocksContent } from '@strapi/blocks-react-renderer';

import { CasesScrollItemDto, CasesSliderResolvedLayout } from '../types';

const hasContent = (value: BlocksContent | string | undefined | null): boolean => {
	if (!value) return false;
	if (typeof value === 'string') return value.trim().length > 0;
	if (Array.isArray(value)) return value.length > 0;

	return Boolean(value);
};

export const getLayoutFromData = (
	cases: CasesScrollItemDto[],
	index: boolean
): CasesSliderResolvedLayout => {
	const hasCases = cases.length > 0;

	return {
		index,
		leftSideTitle: hasCases && cases.some(slide => hasContent(slide.tabLabel)),
		leftSideText: hasCases && cases.some(slide => hasContent(slide.tabDescription)),
		rightSideTitle: hasCases && cases.some(slide => hasContent(slide.slideTitle)),
		rightSideText: hasCases && cases.some(slide => hasContent(slide.slideDescription)),
		rightSideLink: hasCases && cases.some(slide => Boolean(slide.cta?.url))
	};
};
